export default {
  'error.request.error': 'Request Error',
  'error.response.error': 'Response Status Code: ',
  'error.noResponse': 'No response from server, please retry',
  'error.requestFailed': 'Request failed, please retry',
  'error.processingFailed': 'Request processing failed',
};
